import { Icon, Referenz } from 'components/atoms';
import type { BeteiligungsTimelineItem } from 'types';
import { useTranslation } from 'utils/hooks';


import css from './BrutkastenBeteiligungen.module.scss';

interface AnteilProps 
{
  item: BeteiligungsTimelineItem;
}

const BrutkastenAnteil: React.FC<AnteilProps> = (props) =>
{
  const { item } = props;
  const { anteil, kapital, ref } = item;
  const { t } = useTranslation();

  function getFormattedKapital(): string 
  {
    if (kapital.menge === 0 && kapital.währung === '0') 
    {
      return t('profiles:beteiligungen.noBeteiligung');
    }

    return t('formats:money', { value: kapital });
  }

  return (
    <li>
      <Referenz data={ref}>
        {({ iconName }) => (
          <>
            <Icon name={iconName == 'person' ? 'person' : 'building'}/>
            <span className={css.name}>{ref.name}</span>
            {anteil !== null &&
                <span className={css.percent}>{t('formats:percent', { value: anteil > 0 ? anteil / 100 : 0 })}</span>}
            {kapital && <span className={css.kapital}>{getFormattedKapital()}</span>}
          </>
        )}
      </Referenz>
    </li>
  );
};

export default BrutkastenAnteil;